import React, { FC } from 'react';
import style from 'components/shared/detail/assignedUsersView/assignedTask/AssignedTask.module.scss';
import { formatDateTimeUTC } from 'app/utils/date';
import { UserAssignedToPost } from 'types/User';
import { Avatar, Badge, Tooltip } from '@kontentino/ui';

type Props = {
  assignedUser: UserAssignedToPost;
  canEditStatus: boolean;
  onToggle(assignedUser: UserAssignedToPost): void;
};

const AssignedTask: FC<Props> = ({ assignedUser, canEditStatus, onToggle }) => {
  function getLabel() {
    if (assignedUser.task.completed_at) {
      return `Completed at  ${formatDateTimeUTC(
        assignedUser.task.completed_at,
      )}`;
    }

    return `Not completed yet`;
  }

  function getToggleLabel() {
    return canEditStatus
      ? 'Click to toggle status.'
      : 'Only users with assigned tasks can edit the post.';
  }

  function toggleTask() {
    if (canEditStatus) {
      onToggle(assignedUser);
    }
  }

  return (
    <div className={style.assignedTask}>
      <Tooltip content={getLabel()}>
        <div className={style.task}>
          <Avatar
            size={32}
            src={assignedUser.avatar?.src || undefined}
            name={assignedUser.name}
          />
          <span
            className={style.name}
            data-cy="post-preview_assigned-task-user-name"
          >
            {assignedUser.name}
          </span>
        </div>
      </Tooltip>
      {/* TODO do as dropdown when overflow dropdown is resolved*/}
      <Tooltip content={getToggleLabel()}>
        <div
          className={style.status}
          onClick={toggleTask}
          data-cy="post-preview_assigned-task-status-label"
        >
          <Badge variant={!assignedUser.task.completed_at ? 'gray' : 'primary'}>
            {!assignedUser.task.completed_at ? 'Pending' : 'Done'}
          </Badge>
        </div>
      </Tooltip>
    </div>
  );
};

export default AssignedTask;
